export enum ItemDetailsDays {
  ONE_MONTH = 31,
  THREE_MONTHS = 89,
}
